import {BioentityNote, NotePart} from 'notebook/util/NoteUtilConstants';

export default function shallowCopyNote(noteJson: BioentityNote): BioentityNote {
  if (noteJson == null) {
    return noteJson;
  }
  return {
    ...noteJson,
    // VersionedItemSubstore.prepareForStore mutates `note` and each `notePart`, but direct return values
    // from GraphQL cannot be mutated, so this translator makes shallow copies to support that mutation.
    noteParts: noteJson.noteParts.map((notePart: NotePart) => ({
      ...notePart,
      item: notePart.item ? {...notePart.item} : null,
    })),
  };
}
